import Rollbar from 'rollbar';
import packageInfo from '../package.json';

export default () => {
  const rollbarConfig = {
    accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
    autoInstrument: true,
    captureUncaught: true,
    captureUnhandledRejections: true,
    code_version: packageInfo.version,
    environment: process.env.REACT_APP_MODE || 'unknown',
  };
  const rollbar = new Rollbar(rollbarConfig);
  return { rollbar };
};
